/* eslint-disable */
import React from 'react';
// import ReactDOM from "react-dom";
// import { isMobile } from 'react-device-detect';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Skeleton from '@material-ui/lab/Skeleton';
// import { createItem, useItem, getProduct } from 'util/db';
// import analytics from 'util/analytics';
// import {useAuth } from 'util/auth';
import { InputLabel, Select, MenuItem } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Box from '@material-ui/core/Box';
import SimpleImageSlider from "react-simple-image-slider";
import { requireAuth, useAuth } from '../util/auth';
import { useLocalStorage } from '../hooks';

const buttonStyle = { backgroundColor: "black", color: 'white', borderRadius: 30, margin: '25px' };

const ProductModal = (props) => {
  const { closeModal, client } = props;
  const auth = useAuth();
  const [product, handleProduct] = React.useState({
    name: 'Mulburry T Shirt',
    description: 'Navy short-sleeve tee • 12oz cotton jersey fabric • Puff printed Mulberry graphic • Ribbed collar • 100% Cotton • Machine wash • Made in Canada',
    price: '85',
    link: 'https://www.dior.com/en_us/couture/checkout?utm_source=dior&utm_medium=virtualstore&utm_campaign=en_us_virtualstore_diorvibe_checkout',
    addToCart: "{\"fetchStatus\":\"FETCHED\",\"error\":null,\"universeAddingItem\":false,\"errorMessage\":null,\"couture\":{\"billingAddress\":null,\"clickAndCollect\":null,\"csc\":{\"agentId\":null,\"countryZone\":null,\"firstname\":null,\"isOrder\":null,\"lastname\":null},\"deliveryMethod\":null,\"email\":\"\",\"giftMessage\":[],\"id\":\"e984c39be013f5f558de11334f\",\"items\":[{\"clickAndCollect\":true,\"color\":\"M879\",\"detail\":null,\"estimatedDeliveryDate\":null,\"id\":\"M7201ONOA879U\",\"image\":{\"uri\":\"https://media.dior.com/couture/ecommerce/media/catalog/product/5/H/1641221628_M7201ONOA_M879_E01_GH.jpg\",\"width\":460,\"height\":497,\"alt\":\"Medium Dior Vibe Hobo Bag Front view\",\"viewCode\":\"E01\",\"__typename\":\"Image\"},\"inBasketId\":\"cd27a5ce7ebfc2ac16d07ce99f\",\"max\":2,\"price\":\"$3,800.00\",\"priceAndCurrency\":{\"value\":3800,\"currency\":\"USD\"},\"priceAndCurrencyWithoutVat\":{\"value\":3800,\"currency\":\"USD\"},\"priceWithoutVat\":\"$3,800.00\",\"quantity\":1,\"size\":\"\",\"sku\":\"M7201ONOA_M879_TU\",\"skuLegacy\":\"M7201ONOA_M879_TU\",\"tax\":{\"basePrice\":3800,\"name\":null,\"rate\":0,\"taxPrice\":{\"priceAndCurrency\":{\"value\":0,\"currency\":\"USD\"},\"price\":\"$0.00\"}},\"title\":\"Medium Dior Vibe Hobo Bag\",\"undeletable\":null,\"unitPrice\":{\"value\":3800,\"currency\":\"USD\"},\"unitPriceWithoutVat\":{\"value\":3800,\"currency\":\"USD\"},\"unitVat\":0,\"vat\":0,\"abcDiorPrice\":null,\"abcDiorMessage\":null,\"subtitle\":\"White Cannage Lambskin\",\"description\":\"New this season, Maria Grazia Chiuri imagines the Dior Vibe bag with the allure of a Hobo bag showcasing modern lines. The white Cannage lambskin style has a suede calfskin interior while a black 'CHRISTIAN DIOR PARIS' signature adorns the bottom of the bag. Featuring a handle in addition to a removable and adjustable shoulder strap with a military-inspired buckle, the medium Dior Vibe bag can be carried by hand, worn on the shoulder or crossbody for a sportier look.\",\"freeQuantity\":0,\"tracking\":{\"name\":\"Medium Dior Vibe Hobo Bag\",\"id\":\"M7201ONOA_M879_TU\",\"price\":3800,\"brand\":\"Hobo\",\"category\":\"women/handbags/handbags\",\"variant\":\"White\",\"dimension25\":null,\"dimension16\":\"M7201ONOA_M879\",\"dimension48\":\"Women\",\"dimension49\":\"Handbags\",\"dimension50\":\"Handbags\",\"dimension52\":\"female\",\"topCategory\":\"Women\",\"midCategory\":\"Handbags\",\"subCategory\":\"Handbags\",\"gender\":\"female\"},\"code\":\"M7201ONOA_M879\"}],\"nbItems\":1,\"paymentInstruments\":null,\"shippingAddress\":null,\"storeCode\":\"en_us\",\"storeToWeb\":{\"isOrder\":null,\"saName\":null,\"saNumber\":null,\"storeId\":null},\"summary\":{\"subtotalPrice\":{\"priceAndCurrency\":{\"value\":3800,\"currency\":\"USD\"},\"price\":\"$3,800.00\"},\"deliveryMethodPrice\":null,\"taxPrice\":{\"priceAndCurrency\":null,\"price\":\"$0.00\"},\"totalPrice\":{\"priceAndCurrency\":{\"value\":3800,\"currency\":\"USD\"},\"price\":\"$3,800.00\"}},\"subtotalPrice\":null,\"subtotalPriceAndCurrency\":null},\"beauty\":{\"items\":[],\"subtotalPrice\":\"\"}}",
    variationTypes: {
      Sizes: ['XS', 'S', 'M', 'L', 'XL'],
      Colors: ['Black', 'White', 'Green']
    },
    images: [
      { url: 'https://firebasestorage.googleapis.com/v0/b/opengrid-retail.appspot.com/o/products%2F123123123_200x200.png?alt=media' },
      { url: 'https://images.unsplash.com/photo-1643114823006-a0fd52f70670?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=928&q=80' },
    ]
  });

  const [cart, setCart] = useLocalStorage("persist:cart", "");
  const [quantity, setQuantity] = React.useState(1);
  const [selectedSize, handleSize] = React.useState('M');
  const [selectedColor, handleColor] = React.useState('Black');
  // const [imageLoaded, setImageLoaded] = React.useState(true);
  // const [imgUrl, handleImageUrl] = React.useState('https://firebasestorage.googleapis.com/v0/b/opengrid-retail.appspot.com/o/products%2F123123123_200x200.png?alt=media');

  const addToCart = () => {

    let customerInfo;

    if (auth.user) {
      customerInfo = {
        email: auth.user.email || '',
        name: auth.user.displayName || '',
      }
    }
    console.debug('Performance: ', window?.performance);
    setCart({
      ...product,
      quantity: quantity,
      size: selectedSize,
      color: selectedColor,
      customerInfo: customerInfo,
    });
    alert('Added to Cart!');
  }

  const handleOpenShopLink = (productLink) => {
    try {
      window.open(productLink, '_blank');
    } catch (error) { alert(error) }
  }

  // const addOrder = async () => {
  //   try {
  //     await createItem("orders", {
  //       name: product.name,
  //       order: {
  //         sku: product.sku,
  //         price: product.price,
  //         logoUrl: product.logoUrl,
  //         quantity: quantity,
  //         size: selectedSize,
  //         color: selectedColor,
  //       },
  //       total: product.price,
  //       userName: auth.user.name,
  //       email: auth.user.email,
  //       userId: auth.user.id
  //     });
  //     // analytics.track('pressed_order', {
  //     //   ...product, quantity: quantity,
  //     // });
  //     closeModal();
  //   } catch (e) {
  //     console.error("Error adding document: ", e);
  //     analytics.track('order_error', {
  //       ...product, quantity: quantity, error: e
  //     });
  //   }
  // }



  const handleVariationValue = (variationType, value) => {
    if (variationType === 'Sizes') handleSize(value);
    if (variationType === 'Colors') handleColor(value);
  }

  return (<div>

      <div style={{ margin: 'auto', textAlign: 'center', width: '100%', minWidth: '300px', height: '70vh', border: 'none', backgroundColor: 'white' }}>
      <>
        
        <IconButton style={{ position: 'fixed', top: '5px', right: '5px'}} onClick={ closeModal }>
                        <CloseIcon />
        </IconButton>
        <br />
        {product && (<>

        {product?.name &&
          <Typography variant="h6" >{product.name}</Typography>
         
        // :
        //   <Skeleton variant="rectangular" >
        //     <Typography variant="h6">{product?.name}</Typography>
        //   </Skeleton> 
         }
        <Box height={'200px'} style={{ margin: '10px 0'}}>
          <SimpleImageSlider
            width={window.innerWidth}
            height={200}
            images={product?.images}
            showBullets={true}
            showNavs={true}
          />
        </Box>
        {product?.description &&
          <Typography variant="body1"  >{product.description}</Typography>
        //   :
        //   <Skeleton variant="rectangular">
        //     <Typography variant="body1">{product?.description}</Typography>
        //  </Skeleton>
        }
        {/* <br /> */}
       
        {/* {imgUrl &&
            <img src={imgUrl} width="auto" height="100%" style={{ maxHeight: '150px', margin: 'auto', marginBottom: 5, display: imageLoaded ? 'flex' : 'none' }} />
        } */}

        


        {/* {!imageLoaded &&
          <Skeleton variant="rectangular" width="auto" height="50vh" style={{ maxHeight: '50vh'}} />
        } */}

        {product?.price &&
          <Typography variant="h6">$ {product.price}</Typography>
        //   :
        //   <Skeleton variant="rectangular">
        //     <Typography variant="subtitle1">$ {product?.price}.00</Typography>
        //  </Skeleton>
        }

          {product?.variationTypes &&
            <div style={{ display: 'inline-flex' }}>
            {product?.variationTypes?.Sizes && <>
                  <InputLabel id='Sizes' style={{
                margin: 'auto',
                padding: 10,
              }}>Sizes</InputLabel><br />
                  <Select
                    labelId='Sizes'
                    id='Sizes'
                    value={selectedSize}
                    label='Sizes'
                    onChange={(value) => {
                      handleVariationValue('Sizes', value.target.value);
                    }}
                  >
                    {product?.variationTypes.Sizes.map(el =>
                      <MenuItem value={el} key={el}>{el}</MenuItem>
                    )}
              </Select>
            </>}

            {product?.variationTypes && <>
              <InputLabel id='Colors' style={{
                margin: 'auto',
                padding: 10,
              }}>
                Colors
              </InputLabel>
              <Select
                labelId='Colors'
                id='Colors'
                value={selectedColor}
                label='Colors'
                onChange={(value) => handleVariationValue('Colors', value.target.value)}>
              {product?.variationTypes.Colors.map(el =>
                <MenuItem value={el} key={el}>{el}</MenuItem>
              )}
              </Select>
            </>}
            </div>
          }

          {/* <input type='number' style={{ maxWidth: "50px", textAlign: 'right' }} value={quantity} onChange={(e) => setQuantity(e.target.value)} /><br /> */}
              
        <Box  >
          <Button size="medium" variant="contained" style={buttonStyle} onClick={addToCart}>
          Add To Cart
        </Button>
          {product?.link && <Button size="medium" variant="contained" style={buttonStyle}
            onClick={() => handleOpenShopLink(product?.link)}>Checkout</Button>}
        </Box>
        
        </>
        ) }
        </>
    </div>
      </div>);
};



export default requireAuth(ProductModal);
